import $ from 'jquery';
import { fdsClearFieldError, fdsReset, fdsShowFieldError } from 'modals';
import moment from 'moment';

function validateAddFile($modal) {
    const $fileField = $modal.find('input[type="file"]');
    if ($fileField.get(0).files.length === 0) {
        fdsShowFieldError($fileField, 'Du skal vælge en fil.');
        return false;
    }

    const $fileComment = $("#fileComment");
    if ($fileComment.length > 0 && $fileComment.val().trim() === "") {
        fdsShowFieldError($fileComment, 'Bilag skal have en bemærking! Venligst udfyld bemærking.');
        return false;
    }

    $("#mainForm").submit();
    return true;
}

$(() => {
    const $modal = $('#addAttachmentsModal');

    $modal.get(0).addEventListener('fds.modal.hidden', () => {
        fdsReset($modal);
    });

    $modal.find('input[type="file"]').on('change', function () {
        if (this.files[0].size > (15 * 1024 * 1024)) {
            fdsShowFieldError($(this), 'Filens størrelse skal være under 15 MB', 'mb-3');
            $modal.find(':input').val('');
        } else {
            fdsClearFieldError($(this));
        }
    });

    $modal.find('div.date-picker').attr('data-min-date', moment().format('YYYY-MM-DD'));

    $('#addAttachmentsModalAddBtn').on('click', () => {
        return validateAddFile($modal);
    });
});
